<template>
  <button
    class="cityscape-btn"
    :class="{
      ['cityscape-btn--transparent']: props.transparent,
      [ `cityscape-btn--${props.color}`]: !!props.color,
      [ `cityscape-btn--${props.size}`]: !!props.size,
      [`cityscape-btn--disabled`]: props.disabled
    }"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { CityscapeBtnSize, CityscapeBtnColor } from './types'
const props = defineProps<{
    transparent?: boolean
    color?: CityscapeBtnColor
    size?: CityscapeBtnSize
    disabled?: boolean
  }>()
</script>

  <style scoped lang="scss">
  .cityscape-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 40px;
    background: #6B4DFF;
    border-radius: 8px;
    height: 56px;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all .2s ease-in-out;
    font-weight: 600;
    font-size: 18px;
    line-height: normal;
    text-align: center;
    letter-spacing: 0.36px;
    color: #FFFFFF;

    &:hover {
      background: #8D77FA;
    }
    &--secondary{
      background: #00DEBA;
      color: #0D0C33;
      &:hover{
        background: #00C7A6
      }
    }

    &--small{
      height: 44px;
      padding: 4px 32px;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0.28px;
    }

    &--disabled{
      background: #141331 !important;
      color: #3A3A51 !important;
      cursor: not-allowed !important;
      pointer-events: none;
    }

    &--transparent {
      border: 1px solid #6B4DFF;
      background: transparent;
      color: #6B4DFF;

      &:hover {
        // border: 1px solid var(--white-theme-white-000, #FFF);
        background: rgba(255, 255, 255, 0.10);
      }
    }
  }
  </style>
